/**
 * Shown when a non-admin opens /devtools. Blank screen with message to contact admin.
 */

import { useApi, configApiRef } from '@backstage/core-plugin-api';
import { AccessDeniedPage } from '../AccessDeniedPage';

export function DevToolsAccessDeniedPage(): JSX.Element {
  const orgName =
    useApi(configApiRef).getOptionalString('organization.name') ?? 'Backstage';

  return (
    <AccessDeniedPage
      title={orgName}
      description={
        <>
          DevTools is restricted to platform administrators. If you need access,
          please contact your <strong>Backstage / platform administrator</strong> and
          ask them to grant you access.
        </>
      }
    />
  );
}
